import {
    GET_TRANSITION_POSITION_DATA,
    GET_TRANSITION_POSITION_START,
    GET_TRANSITION_POSITION_SINGLE,
    GET_TRANSITION_POSITION_END
} from '../../../actions/types'


const initState = {
    data: [],
    dataSingle: [],
    loading: false,
}

const Red_Position = (state = initState, action) => {
    switch (action.type) {
        case GET_TRANSITION_POSITION_START:
            return {
                ...state,
                loading: action.loading,
            };
        case GET_TRANSITION_POSITION_DATA:
            return {
                ...state,
                data: action.payload,
                loading: action.loading,
            };
        case GET_TRANSITION_POSITION_SINGLE:
            return {
                ...state,
                dataSingle: action.payload,
                loading: action.loading,
            };
        case GET_TRANSITION_POSITION_END:
            return {
                ...state,
                data: action.payload,
                loading: action.loading,
            };
        default:
            return state;
    }
};

export default Red_Position